var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.contentHtml)}},[_c('h2',[_vm._v("DBD Skill Check Simulator")])])
}
var staticRenderFns = []

export { render, staticRenderFns }